/* eslint-disable no-unused-vars */
import { IconButton, Tooltip } from '@material-ui/core';
import { ClearAll, Clear } from '@material-ui/icons';
import React, { useState, useEffect } from 'react';
import { ButtonWrapper, InnerContent, InnerContentWrapper, InnerContentContainer, OuterContent, Wrapper, InnerTopBar, Title, } from './BottomSlidingPane.Styles';
export var BottomSlidingPane = function (_a) {
    var title = _a.title, children = _a.children, iOpen = _a.open, readonly = _a.readonly, component = _a.component, topOffSet = _a.topOffSet, onClose = _a.onClose;
    var _b = useState('medium'), sSize = _b[0], setSize = _b[1];
    var _c = useState(false), sFloat = _c[0], setFloat = _c[1];
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    useEffect(function () {
        setOpen(!!iOpen);
        if (!iOpen) {
            onClose && onClose();
        }
    }, [iOpen]);
    var handleSize = function () {
        setSize(sSize === 'medium' ? 'large' : 'medium');
    };
    // const handleFloat = () => {
    //   setFloat(!sFloat);
    // };
    var handleClose = function () {
        setOpen(false);
        onClose && onClose();
    };
    return (React.createElement(Wrapper, { topOffSet: topOffSet },
        React.createElement(OuterContent, null, children),
        React.createElement(InnerContent, { open: open, size: sSize, floating: sFloat, topOffSet: topOffSet },
            React.createElement(InnerContentWrapper, null,
                React.createElement(InnerTopBar, null,
                    React.createElement(Title, null, title),
                    React.createElement(ButtonWrapper, { disable: !open },
                        React.createElement(Tooltip, { title: sSize === 'medium' ? 'Expand' : 'Contract' },
                            React.createElement(IconButton, { size: 'small', onClick: handleSize },
                                React.createElement(ClearAll, null))),
                        React.createElement(Tooltip, { title: 'Close' },
                            React.createElement(IconButton, { size: 'small', onClick: function () { return onClose && onClose(); } },
                                React.createElement(Clear, null))))),
                React.createElement(InnerContentContainer, { open: open, size: sSize, floating: sFloat, topOffSet: topOffSet, disable: !!readonly }, component)))));
};
BottomSlidingPane.defaultProps = {
    open: false
};
//# sourceMappingURL=BottomSlidingPane.js.map